import en from 'vee-validate/dist/locale/en';
import fr from 'vee-validate/dist/locale/fr';

export const dictionary = {
  'en-CA': {
    ...en,
    custom: {
      password: {
        is_not: 'The new password should be different from the old password',
      },
      'item-name': {
        excluded: 'There is already a duplicate item with the same name',
      },
    },
  },
  'fr-CA': {
    ...fr,
    custom: {
      password: {
        is_not: "Le nouveau mot de passe doit être différent de l'ancien mot de passe",
      },
      'item-name': {
        excluded: 'Il existe déjà un élément en double portant le même nom',
      },
    },
  },
};
